import type { UseFormRegister, UseFormWatch, UseFormSetValue, FieldErrors } from "react-hook-form";
import type { TFunction } from "i18next";
import { Input, PhoneInput } from "@/shared/ui";
import type { OrganizationFormValues } from "../validation";

interface Props {
  register: UseFormRegister<OrganizationFormValues>;
  watch: UseFormWatch<OrganizationFormValues>;
  setValue: UseFormSetValue<OrganizationFormValues>;
  errors: FieldErrors<OrganizationFormValues>;
  t: TFunction;
  disabled: boolean;
  emailTakenMessage?: string;
}

export default function OrganizationContactSection({ register, watch, setValue, errors, t, disabled, emailTakenMessage }: Props) {
  return (
    <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
      <h2 className="text-body-bold-lg content-base-primary pb-3 border-b surface-component-stroke">
        {t("sections.contact.title")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={t("fields.email")}
          placeholder={t("placeholders.email")}
          type="email"
          disabled={disabled}
          error={errors.email?.message ? t(errors.email.message) : emailTakenMessage}
          {...register("email")}
        />
        <PhoneInput
          label={t("fields.phone")}
          disabled={disabled}
          value={watch("phone")}
          onChange={(value) => setValue("phone", value, { shouldDirty: true })}
          error={errors.phone?.message ? t(errors.phone.message) : undefined}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={t("fields.addressRu")}
          placeholder={t("placeholders.addressRu")}
          isTextarea
          disabled={disabled}
          error={errors.address_ru?.message ? t(errors.address_ru.message) : undefined}
          {...register("address_ru")}
        />
        <Input
          label={t("fields.addressKk")}
          placeholder={t("placeholders.addressKk")}
          isTextarea
          disabled={disabled}
          error={errors.address_kk?.message ? t(errors.address_kk.message) : undefined}
          {...register("address_kk")}
        />
      </div>
      <Input
        label={t("fields.activityType")}
        placeholder={t("placeholders.activityType")}
        disabled={disabled}
        error={errors.activity_type?.message ? t(errors.activity_type.message) : undefined}
        {...register("activity_type")}
      />
    </div>
  );
}

